import type { RouteRecordRaw } from 'vue-router';

export const leaveReportsRoutes: RouteRecordRaw[] = [
  {
    path: '/leave-management/reports',
    name: 'LeaveReports',
    component: () => import('../components/LeaveReportsView.vue'),
    meta: {
      title: 'Leave Reports & Analytics',
      requiresAuth: true,
      permissions: ['leave.reports.view']
    }
  }
];